import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Grid, Typography } from '@mui/material';

import { BLACK } from '../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../theme/fontConstants';
import { convertToDollars, isValidNumber, millisecondsToHours } from '../../../../../../utils';

const Title = ({ text }) => (
  <Typography
    sx={{
      fontSize: '16px',
      color: BLACK[100],
      textTransform: 'none',
      fontFamily: PRIMARY_FONT[500],
    }}
  >
    {text}
  </Typography>
);

Title.propTypes = {
  text: PropTypes.string,
};

const Value = ({ text }) => (
  <Typography
    sx={{
      fontSize: '16px',
      color: BLACK[100],
      fontFamily: PRIMARY_FONT[300],
    }}
  >
    {text}
  </Typography>
);

Value.propTypes = {
  text: PropTypes.string,
};

const ContractCardStipend = ({ mealAmount, lodgingAmount, targetHours, prorateDropOff }) => (
  <Grid container spacing={8} display="flex" direction="column">
    <Grid item>
      <Typography
        sx={{
          fontSize: '20px',
          fontFamily: PRIMARY_FONT[700],
          color: BLACK[100],
          lineHeight: '24px',
        }}
      >
        {LanguageConverterV2('contractCard.stipendInformation')}
      </Typography>
    </Grid>
    <Grid item display="flex" gap={4}>
      <Grid item display="flex" gap={1}>
        <Title text={LanguageConverterV2('contractCard.mealAmount')} />
        <Value
          text={
            isValidNumber(mealAmount)
              ? convertToDollars(mealAmount, 2)
              : LanguageConverterV2('noResults.na')
          }
        />
      </Grid>
      <Grid item display="flex" gap={1}>
        <Title text={LanguageConverterV2('contractCard.lodgingAmount')} />
        <Value
          text={
            isValidNumber(lodgingAmount)
              ? convertToDollars(lodgingAmount, 2)
              : LanguageConverterV2('noResults.na')
          }
        />
      </Grid>
      <Grid item display="flex" gap={1}>
        <Title text={LanguageConverterV2('contractCard.targetHours')} />
        <Value
          text={
            isValidNumber(targetHours)
              ? LanguageConverterV2('contractCard.targetHours.hours', {
                  hours: millisecondsToHours(targetHours),
                })
              : LanguageConverterV2('noResults.na')
          }
        />
      </Grid>
      <Grid item display="flex" gap={1}>
        <Title text={LanguageConverterV2('contractCard.prorateDropOff')} />
        <Value
          text={
            isValidNumber(prorateDropOff)
              ? LanguageConverterV2('contractCard.prorateDropOff.hours', {
                  hours: millisecondsToHours(prorateDropOff),
                })
              : LanguageConverterV2('noResults.na')
          }
        />
      </Grid>
    </Grid>
  </Grid>
);

ContractCardStipend.propTypes = {
  mealAmount: PropTypes.number,
  lodgingAmount: PropTypes.number,
  targetHours: PropTypes.number,
  prorateDropOff: PropTypes.number,
};

export default ContractCardStipend;
